import daBoiAvatar from "../client/static/da-boi.webp";
import {
  BookOpen,
  BarChart3,
  Building2,
  Target,
  Timer,
  Zap,
} from "lucide-react";
import { BlogUrl } from "../shared/common";
import type { GridFeature } from "./components/FeaturesGrid";
import type { Translations } from "../client/i18n/translations";

export const getFeatures = (t: Translations): GridFeature[] => [
  {
    name: t.landing.featuresList.propFirmManagement.name,
    description: t.landing.featuresList.propFirmManagement.description,
    icon: Building2,
    accentColor: "#A855F7",
    glowColor: "#A855F7",
  },
  {
    name: t.landing.featuresList.advancedAnalytics.name,
    description: t.landing.featuresList.advancedAnalytics.description,
    icon: BarChart3,
    accentColor: "#3D6EFF",
    glowColor: "#3D6EFF",
  },
  {
    name: t.landing.featuresList.personalizedJournal.name,
    description: t.landing.featuresList.personalizedJournal.description,
    icon: BookOpen,
    accentColor: "#00C9A7",
    glowColor: "#00C9A7",
  },
  {
    name: t.landing.featuresList.disciplineSupport.name,
    description: t.landing.featuresList.disciplineSupport.description,
    icon: Target,
    accentColor: "#F59E0B",
    glowColor: "#F59E0B",
  },
  {
    name: t.landing.featuresList.tradingSessions.name,
    description: t.landing.featuresList.tradingSessions.description,
    icon: Timer,
    accentColor: "#EC4899",
    glowColor: "#EC4899",
  },
  {
    name: t.landing.featuresList.autoSync.name,
    description: t.landing.featuresList.autoSync.description,
    icon: Zap,
    accentColor: "#00C9A7",
    glowColor: "#00C9A7",
  },
];

export const getTestimonials = (t: Translations, language: "fr" | "en") => [
  {
    name: "Alexandre M.",
    role: language === "fr" ? "Day Trader Professionnel" : "Professional Day Trader",
    avatarSrc: daBoiAvatar,
    socialUrl: "#",
    quote: t.landing.testimonialsList.alexandre.quote,
  },
  {
    name: "Sophie L.",
    role: "Swing Trader",
    avatarSrc: daBoiAvatar,
    socialUrl: "#",
    quote: t.landing.testimonialsList.sophie.quote,
  },
  {
    name: "Marc D.",
    role: language === "fr" ? "Trader Débutant" : "Beginner Trader",
    avatarSrc: daBoiAvatar,
    socialUrl: "#",
    quote: t.landing.testimonialsList.marc.quote,
  },
];

export const getFaqs = (t: Translations) => [
  {
    id: 1,
    question: t.landing.faqsList.beginner.question,
    answer: t.landing.faqsList.beginner.answer,
  },
  {
    id: 2,
    question: t.landing.faqsList.propFirm.question,
    answer: t.landing.faqsList.propFirm.answer,
  },
  {
    id: 3,
    question: t.landing.faqsList.freePlan.question,
    answer: t.landing.faqsList.freePlan.answer,
  },
  {
    id: 4,
    question: t.landing.faqsList.import.question,
    answer: t.landing.faqsList.import.answer,
  },
  {
    id: 5,
    question: t.landing.faqsList.multiAccount.question,
    answer: t.landing.faqsList.multiAccount.answer,
  },
  {
    id: 6,
    question: t.landing.faqsList.sessions.question,
    answer: t.landing.faqsList.sessions.answer,
  },
  {
    id: 7,
    question: t.landing.faqsList.security.question,
    answer: t.landing.faqsList.security.answer,
  },
  {
    id: 8,
    question: t.landing.faqsList.export.question,
    answer: t.landing.faqsList.export.answer,
  },
  {
    id: 9,
    question: t.landing.faqsList.dataLoss.question,
    answer: t.landing.faqsList.dataLoss.answer,
  },
];

export const footerNavigation = {
  app: [
    { name: "Documentation", href: BlogUrl },
    { name: "Blog", href: BlogUrl },
  ],
  company: [
    { name: "About", href: "https://wasp.sh" },
    { name: "Privacy", href: "#" },
    { name: "Terms of Service", href: "#" },
  ],
};

